export default "__VITE_ASSET__DP7L9UJU__"